import axios from "axios";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
import { getAccessToken } from "./utils";

export const FETCH_PACKAGE_DETAILS = "FETCH_PACKAGE_DETAILS";
export const FETCH_HISTORY_DETAILS = "FETCH_HISTORY_DETAILS";
export const UPDATE_SELECTED_PACKAGE = "UPDATE_SELECTED_PACKAGE";
export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION";
export const UPGRADE_SUBSCRIPTION = "UPGRADE_SUBSCRIPTION";
export const PROPATED_PRICE = "PROPATED_PRICE";

export const fetchHistoryInfo = () => {
    let companyId = JSON.parse(localStorage.getItem("company")).company_lite_company_id;

    let req = axios
        .get(`${getUrl("subscription")}/invoice/list?company_id=${companyId}&access-token=${getAccessToken()}`, {
            cache: false,

            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((res) => res.data.data)
        .catch((err) => {
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });
    return {
        type: FETCH_HISTORY_DETAILS,
        payload: req,
    };
};

export const updatePackageSelected = (payload) => {
    return { type: UPDATE_SELECTED_PACKAGE, payload };
};

export const cancelSubscription = (data) => {
    let req = axios
        .post(`${getUrl("subscription")}/subscription/cancel?access-token=${getAccessToken()}`, data, {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((res) => {
            console.log(res);
            return res.data;
        })
        .catch((err) => {
            // if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            // else toast.error("Some Error Occured.");
            return err.response.data;
        });

    return {
        type: CANCEL_SUBSCRIPTION,
        payload: req,
    };
};

export const upgradeSubscription = (data) => {
    let req = axios
        .post(`${getUrl("subscription")}/subscription/change?access-token=${getAccessToken()}`, data, {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((res) => {
            console.log(res);
            return res.data.data;
        })
        .catch((err) => {
            // if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            // else toast.error("Some Error Occured.");
            return err.response.data;
        });

    return {
        type: UPGRADE_SUBSCRIPTION,
        payload: req,
    };
};

export const getProratedPrice = (data) => {
    let req = axios
        .post(`${getUrl("subscription")}/subscription/upgrade/proration/preview?access-token=${getAccessToken()}`, data, {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((res) => {
            // console.log(res);
            return res.data.data?.invoice;
        })
        .catch((err) => {
            // if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            // else toast.error("Some Error Occured.");
            return err.response.data;
        });

    return {
        type: PROPATED_PRICE,
        payload: req,
    };
};

export const getAddonsPrice = (data) => {
    let req = axios
        .post(`${getUrl("subscription")}/subscription/addons/invoice/preview?access-token=${getAccessToken()}`, data, {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((res) => {
            console.log(res);
            return res.data.data;
        })
        .catch((err) => {
            // if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            // else toast.error("Some Error Occured.");
            return err.response.data;
        });

    return {
        type: "ADDONS_PRICING",
        payload: req,
    };
};

export const getAddonsCheckout = (data) => {
    let req = axios
        .post(`${getUrl("subscription")}/subscription/addons/invoice/create?access-token=${getAccessToken()}`, data, {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((res) => {
            console.log(res);
            return res.data.data;
        })
        .catch((err) => {
            // if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            // else toast.error("Some Error Occured.");
            return err.response.data;
        });

    return {
        type: "ADDONS_CHECKOUT",
        payload: req,
    };
};

export const scheduleDowngrade = (data) => {
    let req = axios
        .post(`${getUrl("subscription")}/subscription/downgrade/schedule?access-token=${getAccessToken()}`, data, {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((res) => {
            console.log(res);
            return res.data;
        })
        .catch((err) => {
            // if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            // else toast.error("Some Error Occured.");
            return err.response.data;
        });

    return {
        type: "SCHEDULE_DOWNGRADE",
        payload: req,
    };
};

export const cancelDowngrade = (data) => {
    let req = axios
        .post(`${getUrl("subscription")}/subscription/downgrade/cancel?access-token=${getAccessToken()}`, data, {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((res) => {
            console.log(res);
            return res.data;
        })
        .catch((err) => {
            // if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            // else toast.error("Some Error Occured.");
            return err.response.data;
        });

    return {
        type: "SCHEDULE_DOWNGRADE",
        payload: req,
    };
};

export const cancelCancellation = (data) => {
    let req = axios
        .post(`${getUrl("subscription")}/subscription/cancellation/cancel?access-token=${getAccessToken()}`, data, {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((res) => {
            console.log(res);
            return res.data;
        })
        .catch((err) => {
            // if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            // else toast.error("Some Error Occured.");
            return err.response.data;
        });

    return {
        type: "CANCEL_CANCELLATION",
        payload: req,
    };
};

export const setProratedPrice = (payload) => {
    return {
        type: PROPATED_PRICE,
        payload,
    };
};

export const fetchPackageDetails = () => {
    let req = axios
        .get(`${getUrl("subscription")}/config?access-token=${getAccessToken()}`, {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((res) => {
            return res.data.data.prices;
        })
        .catch((err) => {
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });
    return {
        type: FETCH_PACKAGE_DETAILS,
        payload: req,
    };
};

export const getStripeURL = (data) => {
    let req = axios
        .post(`${getUrl("subscription")}/subscription/v2/purchase?access-token=${getAccessToken()}`, data, {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })
        .then((res) => {
            console.log(res);
            return res.data;
        })
        .catch((err) => {
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });

    return {
        type: "GET_STRIPE_URL",
        payload: req,
    };
};
